import { createContext } from 'react';
import type { AuthContextValue } from '@/types';

/**
 * Auth context singleton.
 * Split from AuthProvider.tsx to satisfy react-refresh fast-refresh
 * constraint (a file may export either components or contexts, not both).
 */
export const AuthContext = createContext<AuthContextValue | null>(null);
